<template>
  <UiSection id="results" class="light space-y-6">
    <div class="container mx-auto flex flex-col justify-center space-y-6 lg:flex-row lg:space-x-6 lg:space-y-0">
      <div class="w-1/2">
        <h3 class="mb-2 text-4xl font-bold"><i class="fa fa-trophy" /> Duel</h3>
        <ul class="placements shadow">
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-2xl text-black text-opacity-25">1</div>
            <UiParticipant :info="{ country: 'ru', nick: 'agent' }" />
            <div class="flex-1 px-5 flex items-center justify-end">
              <img class="h-8" src="../../assets/cap.svg" alt="cap" title="Cap" />
              &nbsp;+&nbsp;
              {{ toStringAmount(71300) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-2xl text-black text-opacity-25">2</div>
            <UiParticipant :info="{ country: 'ru', nick: 'dazator' }" />
            <div class="flex-1 px-5 flex items-center justify-end">
              <img class="h-8" src="../../assets/cap.svg" alt="cap" title="Cap" />
              &nbsp;+&nbsp;
              {{ toStringAmount(47500) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-2xl text-black text-opacity-25">3</div>
            <UiParticipant :info="{ country: 'ru', nick: 'danchez' }" />
            <div class="flex-1 px-5 flex items-center justify-end">
              <img class="h-8" src="../../assets/cap.svg" alt="cap" title="Cap" />
              &nbsp;+&nbsp;
              {{ toStringAmount(35600) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-2xl text-black text-opacity-25">4</div>
            <UiParticipant :info="{ country: 'ru', nick: 'pavel' }" />
            <div class="flex-1 px-5 flex items-center justify-end">
              {{ toStringAmount(28500) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-2xl text-black text-opacity-25">5-6</div>
            <UiParticipant class="mr-2" :info="{ country: 'ru', nick: 'cherepoff' }" />
            <UiParticipant :info="{ country: 'ru', nick: 'strongest' }" />
            <div class="flex-1 px-5 flex items-center justify-end">
              {{ toStringAmount(19000) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-2xl text-black text-opacity-25">7-8</div>
            <UiParticipant class="mr-2" :info="{ country: 'ru', nick: 'inz' }" />
            <UiParticipant :info="{ country: 'ru', nick: 'CH3RRA' }" />
            <div class="flex-1 px-5 flex items-center justify-end">
              {{ toStringAmount(8300) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
        </ul>
      </div>
      <div class="w-1/2">
        <h3 class="mb-2 text-4xl font-bold"><i class="fa fa-trophy" /> Draft</h3>
        <ul class="placements shadow">
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-4xl text-black text-opacity-25">1</div>
            <div class="flex flex-wrap justify-start leading-5 text-base text-black text-opacity-50">
              <UiParticipant class="w-1/2 text-red-800" :info="{ country: 'ru', nick: 'cherepoff' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'Troolz' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'Fancje' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: '421' }" />
            </div>
            <div class="flex-1 px-5 flex items-center justify-end">
              4&nbsp;x&nbsp;
              <img class="h-8" src="../../assets/cap.svg" alt="cap" title="Cap" />
              &nbsp;+&nbsp;
              {{ toStringAmount(63300) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-4xl text-black text-opacity-25">2</div>
            <div class="flex flex-wrap justify-start leading-5 text-base text-black text-opacity-50">
              <UiParticipant class="w-1/2 text-red-800" :info="{ country: 'ru', nick: 'pavel' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'strongest' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'noan' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'napalot' }" />
            </div>
            <div class="flex-1 px-5 flex items-center justify-end">
              {{ toStringAmount(44500) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-4xl text-black text-opacity-25">3</div>
            <div class="flex flex-wrap justify-start leading-5 text-base text-black text-opacity-50">
              <UiParticipant class="w-1/2 text-red-800" :info="{ country: 'ru', nick: 'Alostraz' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'ARSENY' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'SMaLLiK' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'aku' }" />
            </div>
            <div class="flex-1 px-5 flex items-center justify-end">
              {{ toStringAmount(31600) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
          <li class="py-2 flex items-center font-bold">
            <div class="px-5 text-4xl text-black text-opacity-25">4</div>
            <div class="flex flex-wrap justify-start leading-5 text-base text-black text-opacity-50">
              <UiParticipant class="w-1/2 text-red-800" :info="{ country: 'ru', nick: 'pecka' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'om3n' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'p5ych0' }" />
              <UiParticipant class="w-1/2" :info="{ country: 'ru', nick: 'k0MnoT' }" />
            </div>
            <div class="flex-1 px-5 flex items-center justify-end">
              {{ toStringAmount(15800) }}
              <i class="fa fa-ruble-sign ml-1" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="container mx-auto flex flex-col justify-center space-y-6 lg:flex-row lg:space-x-6 lg:space-y-0">
      <div class="w-1/2">
        <h3 class="mb-2 text-4xl font-bold"><i class="fa fa-photo-video" /> Media</h3>
        <ul class="media shadow bg-gray-400">
          <li class="py-1 flex items-center">
            <div class="px-3 text-black text-opacity-50">
              <i class="fab fa-twitch fa-fw" />
            </div>
            <div class="flex items-center font-bold">
              <UiFlag class="mr-1" country="ru" />
              DeathmatchTV VODs:&nbsp;
              <a href="https://www.twitch.tv/videos/759240698" target="_blank">{{ t('day') }} 1</a>,&nbsp;
              <a href="https://www.twitch.tv/videos/760274839" target="_blank">{{ t('day') }} 2</a>
            </div>
          </li>
          <li class="py-1 flex items-center">
            <div class="px-3 text-black text-opacity-50">
              <i class="fab fa-twitch fa-fw" />
            </div>
            <div class="flex items-center font-bold">
              <UiFlag class="mr-1" country="gb" />
              TimconLAN VODs:&nbsp;
              <a href="https://www.twitch.tv/videos/759242690" target="_blank">{{ t('day') }} 1</a>,&nbsp;
              <a href="https://www.twitch.tv/videos/760267725" target="_blank">{{ t('day') }} 2</a>
            </div>
          </li>
          <li class="py-1 flex items-center">
            <div class="px-3 text-black text-opacity-50">
              <i class="fa fa-film fa-fw" />
            </div>
            <div class="flex items-center font-bold">
              <UiFlag class="mr-1" country="ru" />
              <a href="https://www.youtube.com/watch?v=CCuPqAo5yZY" target="_blank">{{ t('videoReportBy') }} Factory</a>
            </div>
          </li>
          <li class="py-1 flex items-center">
            <div class="px-3 text-black text-opacity-50">
              <i class="fa fa-video fa-fw" />
            </div>
            <div class="flex items-center font-bold">
              <UiFlag class="mr-1" country="ru" />
              <a href="https://www.twitch.tv/ileeiv/videos" target="_blank">IRL {{ t('videoBy') }} iLeeiV</a>
            </div>
          </li>
          
          <li class="py-1 flex items-center">
            <div class="px-3 text-black text-opacity-50">
              <i class="fa fa-file-alt fa-fw" />
            </div>
            <div class="flex items-center font-bold">
              <UiFlag class="mr-1" country="ru" />
              <a href="https://cyber.sports.ru/tribuna/blogs/factory/2842147.html" target="_blank">{{ t('reportBy') }} Factory</a>
            </div>
          </li>
          <li class="py-1 flex items-center">
            <div class="px-3 text-black text-opacity-50">
              <i class="fa fa-file-alt fa-fw" />
            </div>
            <div class="flex items-center font-bold">
              <UiFlag class="mr-1" country="gb" />
              <a href="https://factory-esports.com/news/factory-news/factory-diabotical-invitational-results" target="_blank">{{ t('reportBy') }} Factory</a>
            </div>
          </li>

          <li class="py-1 flex items-center">
            <div class="px-3 text-black text-opacity-50">
              <i class="fa fa-file-alt fa-fw" />
            </div>
            <div class="flex items-center font-bold">
              <UiFlag class="mr-1" country="ru" />
              <a href="https://telegra.ph/1234-10-05-2" target="_blank">{{ t('reportBy') }} AVBSPB</a>
            </div>
          </li>
          <li class="py-1 flex items-center">
            <div class="px-3 text-black text-opacity-50">
              <i class="fa fa-file-alt fa-fw" />
            </div>
            <div class="flex items-center font-bold">
              <UiFlag class="mr-1" country="gb" />
              Liquipedia:&nbsp;
              <a href="https://liquipedia.net/arenafps/Factory_Diabotical_Invitational" target="_blank">Duel</a>,&nbsp;
              <a href="https://liquipedia.net/arenafps/Factory_Diabotical_Draft" target="_blank">Draft</a>
            </div>
          </li>
          <li class="py-1 flex items-center">
            <div class="px-3 text-black text-opacity-50">
              <i class="fa fa-images fa-fw" />
            </div>
            <div class="flex items-center font-bold">
              <a href="https://yadi.sk/d/xZXqhdPlaEkSpQ" target="_blank">{{ t('photos') }} 1</a>,
              &nbsp;
              <a href="https://yadi.sk/d/uGBT0GEMrXardQ" target="_blank">{{ t('photos') }} 2</a>
            </div>
          </li>
        </ul>
      </div>
      <div class="w-1/2">
        <img class="rounded" src="https://i.imgur.com/wqtpnia.jpg" alt="" />
      </div>
    </div>
    <div class="flex space-x-4">
      <div class="flex-1">
        <iframe width="100%" height="400" src="https://widget.toornament.com/tournaments/3907605543952646144/stages/3907606869461385216/?_locale=en_US" allowfullscreen />
      </div>
      <img class="rounded border-2 border-gray-400" src="https://i.imgur.com/bCOp9NR.png" alt="" style="height: 400px" />
    </div>
    <div class="flex space-x-4">
      <div class="flex-1">
        <iframe width="100%" height="400" src="https://widget.toornament.com/tournaments/3907605543952646144/stages/3907614361659580416/?_locale=en_US" allowfullscreen />
      </div>
      <img class="rounded border-2 border-gray-400" src="https://i.imgur.com/FjkXpMi.png" alt="" style="height: 400px" />
    </div>
    <div>
      <iframe width="100%" height="2150" src="https://widget.toornament.com/tournaments/3866265104071237632/stages/3970792387928948736/?_locale=en_US" allowfullscreen />
    </div>
  </UiSection>
</template>

<script>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { menu } from '../../store.js'

  export default {
    name: 'SectionResults',
    setup() {
      const { t } = useI18n({
        messages: {
          en: {
            header: 'Results',
            day: 'Day',
            photos: 'Photos',
            reportBy: 'Report by',
            videoReportBy: 'Video report by',
            videoBy: 'video by',
          },
          ru: {
            header: 'Результаты',
            day: 'День',
            photos: 'Фотографии',
            reportBy: 'Отчет от',
            videoReportBy: 'Видео-отчет от',
            videoBy: 'видео от',
          },
        },
      })

      function toStringAmount(donate = 0) {
        const string = Math.round(donate).toString()
        return donate / 10000 >= 1 ? string.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : string
      }

      menu.results = {
        name: computed(() => t('header')),
        icon: 'fa fa-trophy',
      }

      return { t, toStringAmount }
    },
  }
</script>

<style>
  .placements li:nth-child(1) {
    background-color: #ffa;
  }
  .placements li:nth-child(2) {
    background-color: #ffd;
  }
  .placements li:nth-child(3) {
    background-color: #fec;
  }
  .placements li:nth-child(4) {
    background-color: #eed;
  }
  .placements li:nth-child(5) {
    background-color: #ddc;
  }
  .placements li:nth-child(6) {
    background-color: #ccb;
  }
  .flag-icon {
    width: 1em;
    height: 0.75em;
  }
</style>
